var _style, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _path8, _circle3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 379",
    style: {
      enableBackground: "new 0 0 500 379"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#1a2e35}.st1{fill:#007cff}.st3{fill:#fff}.st5,.st6{enable-background:new}.st5{opacity:.4;fill:#fff}.st6{opacity:.2}.st8,.st9{enable-background:new}.st8{opacity:.6;fill:#fff}.st9{opacity:.1}.st10{fill:#fcb373}.st12{fill:none;stroke:#1a2e35;stroke-width:.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.5 272.1H35.9c0-1.9 1.3-3.5 3.1-4l12.3-3.3v-68.6h4.8v68.6l12.3 3.3c1.9.5 3.1 2.1 3.1 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.7 218.2H16.8l5.9-61.8h62z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.7 218.2H16.8l5.9-61.8h62z",
    style: {
      opacity: 0.4,
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5 272.1H35.9c0-1.9 1.3-3.5 3.1-4l12.3-3.3V239l4.8-2.2v27.9l12.3 3.3c1.9.6 3.1 2.2 3.1 4.1z",
    style: {
      opacity: 0.2,
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.1 369.2h-5l-2.4-14.5h7.4zm-76.7 0h4.9l2.4-14.5h-7.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.1 274.2h83.1v84.2H12.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.7 272.1h80c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6h-80c-2 0-3.6-1.6-3.6-3.6.1-2 1.7-3.6 3.6-3.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M13.7 272.1h80c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6h-80c-2 0-3.6-1.6-3.6-3.6.1-2 1.7-3.6 3.6-3.6zm3.6 12.6h72.9v19H17.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 53.7,
    cy: 294,
    r: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.3 308.6h72.9v19H17.3z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 53.7,
    cy: 318,
    r: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.3 332.5h72.9v19H17.3z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 53.7,
    cy: 341.9,
    r: 2.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.5 193.4v135.9h333.4V193.4c0-7.2-5.9-13.1-13.1-13.1H146.6c-7.3 0-13.1 5.8-13.1 13.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M133.5 193.4v135.9h333.4V193.4c0-7.2-5.9-13.1-13.1-13.1H146.6c-7.3 0-13.1 5.8-13.1 13.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 300.135 342.43)",
    className: "st1",
    d: "M141.7 320.2h316.9v44.5H141.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 300.135 342.43)",
    className: "st5",
    d: "M141.7 320.2h316.9v44.5H141.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.9 257.2v105c0 3.8 3.1 6.9 6.9 6.9h37.3c3.8 0 6.9-3.1 6.9-6.9v-105c0-3.8-3.1-6.9-6.9-6.9h-37.3c-3.8 0-6.9 3.1-6.9 6.9zm-340.7 0v105c0 3.8 3.1 6.9 6.9 6.9h37.3c3.8 0 6.9-3.1 6.9-6.9v-105c0-3.8-3.1-6.9-6.9-6.9h-37.3c-3.8 0-6.9 3.1-6.9 6.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M444.9 257.2v105c0 3.8 3.1 6.9 6.9 6.9h37.3c3.8 0 6.9-3.1 6.9-6.9v-105c0-3.8-3.1-6.9-6.9-6.9h-37.3c-3.8 0-6.9 3.1-6.9 6.9zm-340.7 0v105c0 3.8 3.1 6.9 6.9 6.9h37.3c3.8 0 6.9-3.1 6.9-6.9v-105c0-3.8-3.1-6.9-6.9-6.9h-37.3c-3.8 0-6.9 3.1-6.9 6.9z",
    style: {
      enableBackground: "new",
      opacity: 0.5,
      fill: "#fff"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.7 295v27.1c0 4 3.2 7.2 7.2 7.2h296.5c4 0 7.2-3.2 7.2-7.2V295c0-4-3.2-7.2-7.2-7.2H151.9c-1 0-2 .2-2.9.6-2.5 1.1-4.3 3.7-4.3 6.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M144.7 295v27.1c0 4 3.2 7.2 7.2 7.2h296.5c4 0 7.2-3.2 7.2-7.2V295c0-4-3.2-7.2-7.2-7.2H151.9c-1 0-2 .2-2.9.6-2.5 1.1-4.3 3.7-4.3 6.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m149 288.4.1.7s-.3 8.5 1.9 12.3c.5.8 2.1.9 4.3.7 8.8-.9 27.5-7.8 27.5-7.8s34.2 18.2 164.2 0c0 0 26.3 29.1 29.5 28.2 2.6-.8 23.5-25.9 30.7-34.6l-233.1-7-18.7-1.7-7.3.9.9 8.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M331.3 275c3.2 4.6 63.1 22.5 70.8 18.9 7.5-3.6 35.7-58.9 32.6-65.7l-.2-.3c-5.1-6.1-63.6-25.7-65.8-25.8-1.4 0-15.3 24-25.8 44.5-7.3 14-12.9 26.5-11.6 28.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M331.3 275c3.2 4.6 63.1 22.5 70.8 18.9 7.5-3.6 35.7-58.9 32.6-65.7l-.2-.3s-17.6 11-26.6 21.6c-9 10.6-12.2 22.9-12.2 22.9l-29.9.5s-12.5-18.1-23-26.3c-7.2 14-12.8 26.5-11.5 28.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158 291.2c3.4 1.8 46.6-17.9 50.7-22.3 4.1-4.5-.7-10.8-.7-10.8s-6.3-14.4-12.5-28.4c-5-11.3-10-22.4-11.7-25.6-3.7-7.1-49.2 6.7-57.3 7.9-.9.1-1.4 1-1.6 2.5-1.6 12.7 19.5 69.6 33.1 76.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M158 291.2c3.4 1.8 46.6-17.9 50.7-22.3 4.1-4.5-.7-10.8-.7-10.8s-6.3-14.4-12.5-28.4c-22.2-4-48.8-7-48.8 1.3 0 14.2 16.1 51 16.1 51-1.9 4.3-6 2.8-6 2.8s-6.6-24.5-12.9-41.8c-6.2-17.3-17.4-31-17.4-31l-1.6 2.5c-1.6 12.7 19.5 69.6 33.1 76.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__2_"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M219.2 195.3s-6.3 3.7-8.8 6.3c-2.4 2.6-5.3 15.2-6.5 18.5-1.1 3.3 8.5 8.7 10.4 8.7s4.4-16.3 4.4-18.6c.1-2.4-1.7-4.7-1.7-4.7l7.3-5.3-5.1-4.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.3 166.3s52.5-9.5 54.7 6.5c2.3 16-33.5 33.4-33.5 33.4l-9.3-7.4s21-15.1 20.2-18.5c-.8-3.4-33 6.6-33 6.6l.9-20.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.2 197.4c-1.2.8-1.9 1.4-1.9 1.4l.1.1 9.2 7.3s35.7-17.4 33.5-33.4c-.9-6.3-9.6-8.6-19.8-9.2-15.7-.8-34.9 2.7-34.9 2.7l-.8 20.5s20.3-6.3 29-7.2c2.3-.2 3.8-.1 3.9.6.7 2.9-13.2 13.4-18.3 17.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M199.6 186.9s20.3-6.3 29-7.2c3.4-6.2 5.5-11.9 6.7-16-15.7-.8-34.9 2.7-34.9 2.7l-.8 20.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m407.9 284.3-2.5-9.4-21.9 4.9 2.4 9.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m404 273.9 2.9 11.4c.1.4.5.6.9.6l8.8-.3c.8 0 1.4-.7 1.4-1.5v-.3c-1-3.7-1.9-6.3-3.1-10.9-.7-2.9-2.7-11.5-3.7-15.5-1-3.9-5-3.5-5-1.7.3 7.6-.5 13.6-2 16.5-.3.5-.3 1.1-.2 1.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.2 272.9c0 .1-.1.2-.1.2-.1 0-.2 0-.2-.1-.3-.3-2.9-2.8-2.7-4 .1-.3.3-.5.5-.5.4-.2.9-.1 1.3.2.5.4.8 1 .9 1.7.2.8.3 1.7.3 2.5zm-.5-.5c.1-1.2-.3-2.4-1-3.3-.3-.2-.6-.2-.9-.1-.2.1-.2.2-.2.2v.3c.5 1.1 1.2 2.1 2.1 2.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.2 273c0 .1-.1.1-.2.2-.1 0-2.9.5-4.1-.4-.3-.2-.5-.5-.5-.9-.1-.3.1-.7.4-.9.9-.4 3.5.9 4.3 1.7v.1c.1.1.1.2.1.2zm-4-.6c1 .4 2.1.6 3.2.4-1-.8-2.8-1.6-3.4-1.3-.1 0-.2.1-.1.4v.1c0 .2.1.3.3.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m385.9 289.2-2.4-9.4 11.3-2.5 2.5 9.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m383.5 310.5 5.9-7.7-17.4-14.3-5.9 7.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m389.3 301-7.1 9.4c-.2.3-.2.8 0 1.1l5.7 6.8c.5.6 1.4.7 2 .2.1-.1.2-.1.2-.2 2.3-3.1 3.8-5.4 6.7-9.2 1.8-2.3 7.4-9.2 9.9-12.5 2.5-3.2-.4-6.1-1.7-5-5.8 5-11 8.1-14.2 8.7-.6-.1-1.1.3-1.5.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.8 301.3c-.1.1-.2.1-.3 0-.1 0-.1-.1-.1-.2 0-.4.4-4.1 1.5-4.6.2-.1.5-.1.7.1.4.2.7.7.7 1.1 0 .7-.3 1.3-.7 1.8-.5.7-1.2 1.3-1.8 1.8zm.1-.7c1-.7 1.7-1.7 2-2.8 0-.3-.2-.6-.5-.7-.2-.1-.3-.1-.3 0-.1 0-.2.1-.2.2-.6.9-.9 2.1-1 3.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.8 301.4h-.2c-.1-.1-2.2-2-2.2-3.4 0-.4.1-.7.4-1 .2-.3.6-.4.9-.2.9.5 1.5 3.3 1.3 4.4l-.1.1c-.1 0-.1.1-.1.1zm-2.1-3.5c.3 1.1.9 2 1.7 2.8 0-1.3-.5-3.2-1.1-3.5-.1 0-.2-.1-.4.1l-.1.1c0 .1-.1.3-.1.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m366.1 296.3 5.9-7.8 9 7.4-5.9 7.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m164.5 248.2 6 25.1c2 35.3 116.6 21.9 155.8 19.9 2.1-.1 5-.2 8.4-.4 16.3-.7 44.6-1.8 53.4-2.1 1.7-.1 2.7-.1 2.7-.1l-.4-15.8c-3.6.1-8 0-13.1-.1-1.7-.1-3.6-.1-5.4-.2-17-.8-40-2.6-63.9-4.7-.7-.1-1.3-.1-2-.2-57.9-5.3-120.9-12.6-120.9-12.6l-20.6-8.8z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m391.4 271.4 5.2 20.2-6 1.6-5.9-20.9z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m391.4 271.4 5.2 20.2-6 1.6-5.9-20.9z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M305.9 269.5c8.1 6 19.9 15.9 28.7 23.3 16.3-.7 44.6-1.8 53.4-2.1l-16.3-16.3c-17-.8-40-2.6-63.9-4.7-.5-.1-1.2-.1-1.9-.2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.5 273.3c23.9 34.5 81.1-7.9 81.1-7.9.6-.3 1.3-.6 2-.8 8-3.2 19.3-6.1 25.5-7.8.9-.2 1.6-.5 2.2-.7 3.3-1 5.8-1.5 7.5-1.1 1.6.4 3.8 1.2 6.4 2.3 22.2 9.9 75.9 45.6 75.9 45.6l9.5-12.7s-11.2-10.3-26.7-22.6c-22.6-17.8-54.2-39.7-73.1-39.7-31.9 0-73.5 19.2-73.5 19.2l-23-12.5-13.8 38.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m383.5 289.5-12.7 16.7-5-3.8 12.9-17.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m383.5 289.5-12.7 16.7-5-3.8 12.9-17.5z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m218.8 262.1 34.8 2.5c8-3.2 19.3-6.1 25.5-7.8-32.4-.2-60.3 5.3-60.3 5.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m172.5 284.1 39-40c-5.9-2.3-9.7-6.2-12-11.1-3.4-7-3.7-15.8-2.7-23.8.5-3.8 1.2-7.4 2.1-10.5 4-14.4 1.7-29.6 1.7-29.6-25.9-5.4-54.9 7.9-56.7 19.7-7.5 50.2 28.6 95.3 28.6 95.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m212.7 180.2 5-8.6s.7-4.4 1.5-6.5c.9-2.1 12.8-5 16.3-3.1s4.4 2 4.4 2-4.8 8.4-7.3 9.6c-2.5 1.2-6.3 1.1-6.3 1.1l-7.1 10.1-6.5-4.6zm-42.2 1.7c3.3 3 9.4 3.3 12.8 3.2 1.4 0 2.4-.2 2.4-.2-.4-2.5 6.8-6 6.8-6l-6.5-12-.3-.5c-.2.2-.5.4-.7.6-.9.8-1.8 1.4-2.7 1.8-4.1 2.2-7.6 1.4-7.6 1.4s-11.8 4.6-4.2 11.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M183.2 185c1.4 0 2.4-.2 2.4-.2-.4-2.5 6.8-6 6.8-6l-6.5-12-1 .1-2.1.3s-.3.6-.6 1.6c-1.1 3.3-3.1 11 1 16.2z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221 165s-7.9 10.9-16.6 9.6c-8.7-1.3 8.8-19 8.8-19l7.8 9.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M182.3 167.7c-1 5.9 2 10.8 6.6 13.1 2.9 1.5 6.5 1.9 9.9 1 .5-.1.9-.3 1.4-.5 8.2-3.3 19.1-12.7 16.7-22.6-1.6-7.1-8.7-11.5-15.8-9.8-2 .5-3.9 1.4-5.5 2.7-7.5 6.1-12.2 9.3-13.3 16.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205 170.2c-1.4 2.1-2.5 4.5-3.3 6.9-1.3-.4-2.3-1.4-2.8-2.6l6.1-4.3z",
    style: {
      fill: "#b84d3c"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.6 161.1c.1.2.2.3.4.3 1.2 0 2.3.6 3 1.5.1.2.4.3.6.2.2-.1.3-.4.2-.6-.8-1.2-2.2-1.9-3.7-1.9-.3 0-.5.2-.5.4-.1 0-.1.1 0 .1zm9.1 12.4c0 .1.1.2.1.2.2.1.5 0 .6-.2.7-1.3.8-2.8.2-4.2-.1-.2-.4-.3-.6-.2-.2.1-.3.4-.2.6.5 1.1.4 2.3-.2 3.3 0 .3 0 .4.1.5zm-2.3-23.1-3 3c-1.4-.6-3.2-.3-4.1 1.2-1.9 3.3-7.5 5.1-10.9 4.3 0 0 1.2-1 .1-1.8-1.1-.8-7.2 4.5-8.6 8.8 0 0 .3-5.2 5.6-12.1 4.9-6.4 9.8-10.6 13.2-11.3l7.7 7.9z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M203 166.8s-2.7.3-3.4-1.8m8.4 6.7s-.6 2.2 1.4 2.7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.7 172.1c.4.2.8.6 1.1.9.6.8 1.9 2.3 1.4 3.4-.4 1-2.4-1.3-2.7-1.6-.4-.5-1-1.2-1-1.8 0-1.2.6-1.2 1.2-.9zm13.2-20.6s-.1 8.6 4.7 11.5c0 0-1.9-2.6-1.5-5.5 0 0 2.6 9.5 5.9 10.5 3.3 1 2.4 4.5 5.8 4.5s4.9-6.6 4.9-6.6 1.7 1.1 2.4-2.6-.5-4.6-1.5-6.5c-1-1.8 3.1-3.6 2.1-7.4-1-3.9-8.1-12.6-13.6-7.6 0 0-1.7-5.8-8.4-4.5-3.3.7-2.9 3.1-2.9 3.1s-1.7-3.3-7.9-.9c-6.2 2.3-7.7 10-7.7 10s-1.6-1-2.7 3.6.8 7.4.8 7.4 9.9-11.7 19.6-9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M186.7 152.8c-1.1 2.1-1.4 4.6-.7 6.9.9 3.1 4.1 2.9 6.1.6 1.8-2.1 3.5-6.2 1.4-8.5-2.1-2.4-5.4-1.6-6.8 1z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M224.7 156.2s3.8 3.2 5.5.4m-6.5 7.4s2.7 4.4-.9 8.1m-19.6-30.6s-1-3.1.8-5.6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M203 140.4s-7.4-5.5-13.8 1.8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.2 197.4c-1.2.8-1.9 1.4-1.9 1.4l.1.1 1.8-1.5zm-65.1 11.1s22.1 34.8 47 25.9c1.2-.4 2.3-.8 3.3-1.3-3.4-7-3.7-15.8-2.7-23.8-3 3.3-7.1 6.6-11.1 6.2-7.6-.8-36.5-7-36.5-7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.8 188.9c4.6-8.1 41.3 21.3 45.3 19.1 4-2.2 25-33.6 25-33.6l10.6 5.3s-18 37.9-25.1 44.9c-9.2 9-44.7-6.2-49.9-12.5-5-6.4-9-17.8-5.9-23.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M143.8 188.9c4.6-8.1 41.3 21.3 45.3 19.1 4-2.2 25-33.6 25-33.6l10.6 5.3s-18 37.9-25.1 44.9c-9.2 9-44.7-6.2-49.9-12.5-5-6.4-9-17.8-5.9-23.2z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m210.6 236 28.6 5.4s-9.4 12.3-11.9 21.3c0 0-14.1 5.9-18.4 17.2L182 270s3.6-10.4 19.3-16.5c0 0 1.6-13.1 9.3-17.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m210.6 236 28.6 5.4s-9.4 12.3-11.9 21.3c0 0-14.1 5.9-18.4 17.2L182 270s3.6-10.4 19.3-16.5c0 0 1.6-13.1 9.3-17.5z",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m235.7 237.2.3 2.2 1.3-.4-.5 2.5s-8 8-10.3 20.2c0 0-13 7.4-17.7 16.6l-27.4-10.1.5-.8-1.5-.3 22-15 5.2-16 28.1 1.1z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m235.7 237.2.3 2.2 1.3-.4-.5 2.5s-8 8-10.3 20.2c0 0-13 7.4-17.7 16.6l-27.4-10.1.5-.8-1.5-.3 22-15 5.2-16 28.1 1.1z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M226.4 261.7s-8.6 2.4-17.1 16L179.6 266s6.7-12 19.6-14.5c0 0 1.4-12.1 7.9-18l2.5.3 26 3.4c.1 0-9.3 17.1-9.2 24.5z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m226.4 261.7-27.2-10.2s1.4-12.1 7.9-18l2.5.3c-1.2 3.1-2 7.4-.2 11.1 3.5 7 17 16.8 17 16.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.3edf9af3475afda048d83dc2ecf1d979.svg";
export { ForwardRef as ReactComponent };